import { fetcher } from '@commenda/utils';

export async function deleteSalesTaxFiling(
  filingId: string,
  corporationId: number
): Promise<{ success: boolean; error?: string }> {
  try {
    const response = await fetcher(
      `new-sales-tax/filings/${filingId}?corporation_id=${corporationId}`,
      {
        method: 'DELETE',
      }
    );

    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      return {
        success: false,
        error: data.message || 'Failed to delete filing',
      };
    }

    return { success: true };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}
